import { createServerFn } from "@tanstack/react-start";

import { isDraftVisibleForHost } from "@/lib/draft-pages";

/** Server-side host check for draft-only routes (runs directly during SSR). */
export const getDraftVisibility = createServerFn({ method: "GET" }).handler(
  async () => {
    const { getRequestHeader } = await import("@tanstack/react-start/server");
    const host =
      getRequestHeader("x-forwarded-host") ?? getRequestHeader("host");
    return { visible: isDraftVisibleForHost(host) };
  },
);
